module.exports = __webpack_public_path__ + "img/KSC02600.95bf39b9.jpg";